import { JournalDraftEntryDatableDocument } from 'generated/resources/datatable.graphql'
import {
  AccountingDraftEntriesCountWidgetDocument,
  JournalDraftEntryDetailSidepanelQuery,
  JournalEntryDetailSidepanelQuery,
} from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'

import { JournalEntryTab } from 'modules/finance/components/JournalsEntry/JournalEntryTab'
import { JournalDraftEntryTab } from 'modules/finance/components/JournalsEntry/JournalEntryTab/JournalDraftEntry'

interface Props {
  data?: JournalEntryDetailSidepanelQuery | JournalDraftEntryDetailSidepanelQuery
  loading: boolean
  onClose: () => void
}

function isJournalEntryDetailSidepanelQuery(
  data: JournalEntryDetailSidepanelQuery | JournalDraftEntryDetailSidepanelQuery
): data is JournalEntryDetailSidepanelQuery {
  return (
    data &&
    typeof data === 'object' &&
    'finance' in data &&
    typeof data.finance === 'object' &&
    'journalEntry' in data.finance
  )
}

const JournalEntryDetailContent = ({ data, loading, onClose }: Props) => {
  const journalEntry =
    data && isJournalEntryDetailSidepanelQuery(data) && data?.finance?.journalEntry
  const journalDraftEntry =
    data && !isJournalEntryDetailSidepanelQuery(data) && data?.finance?.journalDraftEntry
  const canManageJournalEntries = data?.finance?._policies?.journalEntriesManage?.can ?? false

  const authorized = !!(journalEntry || journalDraftEntry) && canManageJournalEntries

  if (loading) {
    return <Loading />
  } else if (!authorized || (!journalEntry && !journalDraftEntry)) {
    return <NotFound />
  }

  if (journalEntry) {
    return (
      <JournalEntryTab
        journalEntry={journalEntry}
        legalEntity={journalEntry.legalEntity}
        currency={journalEntry.legalEntity.currency}
      />
    )
  }

  if (journalDraftEntry) {
    return (
      <JournalDraftEntryTab
        journalDraftEntry={journalDraftEntry}
        legalEntity={journalDraftEntry.legalEntity}
        currency={journalDraftEntry.legalEntity.currency}
        onRecord={onClose}
        refetchQueriesOnRecord={[
          AccountingDraftEntriesCountWidgetDocument,
          JournalDraftEntryDatableDocument,
        ]}
      />
    )
  }

  return null
}

export default JournalEntryDetailContent
